import { inject } from "vue";
import { i18nSymbol } from "@/i18n";
import type Translator from "@/i18n/Translator";
import type { TranslationKeys } from "@/i18n/shared-types";

export function useTranslator() {
  return inject(i18nSymbol) as Translator<Record<TranslationKeys, any>>;
}
